import RegistrationsToolBar from "@/components/registrations/registrations-table/registrations-table-tool-bar.vue";
import RegistrationsTableViewDialog from "@/components/registrations/registrations-table/view-dialog/registrations-table-view-dialog.vue";
import CertificatesNewFiltersIndex from "@/components/certificates/certificates-filters/certificates-filters-index.vue";
import GlobalDetailsPopup from "@/components/global/global-details-popup.vue";
import GlobalMsgAlert from "@/components/global/global-msg-alert.vue";
import RegistrationsChangeStatus from "@/components/registrations/registrations-table/actions/registrations-change-status.vue";
import RegistrationsChangePassword from "@/components/registrations/registrations-table/actions/registrations-change-password.vue";
import RegistrationsTableMobileView from "@/components/registrations/registrations-table/registrations-table-mobile-view.vue";
import GlobalPaginationTemplate from "@/components/global/global-pagination-template.vue";
import RegistrationsTableRowMenu from "@/components/registrations/registrations-table/table-index/registrations-table-row-menu.vue"
import { getFormatedDate } from "@/Mixins/dateFormatMixin";
import tableMethods from "@/Mixins/tableMixins";
import { getProtocolColor } from "@/Mixins/registrations/protocolColorMixin";
import { getStatusColorReg } from "@/Mixins/registrations/statusMixin";
import { actionResponse } from "@/Mixins/actionResponse";
import { mapActions, mapGetters } from "vuex";
import { ref } from "vue";
import pgwyClient from "@/api/pgwyClient";
import { REGISTRATION_HEADERS } from "@/config/registration-headers";
import RegistrationsFiltersIndex from "@/components/registrations/registrations-filters/registrations-filters-index.vue";

export default {
  mixins: [getFormatedDate, tableMethods, getProtocolColor, getStatusColorReg, actionResponse],
  components: {
    RegistrationsFiltersIndex,
    RegistrationsToolBar,
    RegistrationsTableViewDialog,
    CertificatesNewFiltersIndex,
    GlobalDetailsPopup,
    GlobalMsgAlert,
    RegistrationsChangeStatus,
    RegistrationsChangePassword,
    RegistrationsTableMobileView,
    GlobalPaginationTemplate,
    RegistrationsTableRowMenu,
  },
  setup() {
    const registrationsToolBar = ref();
    return { registrationsToolBar };
  },
  data() {
    return {
      sortByColumn: "",
      sortDescending: false,
      dateFormat: "YYYY/MM/DD hh:mm [CET]",
      isMobileView: false,
      goToPageModel: 1,
      goToPageFormValid: true,
      goToPageRules: [
        (v) => !!v || "Can't be empty",
        (v) => (v && v > 0) || "Number has to be greater than 0",
        (v) =>
          v <
          Math.ceil(this.getRegistrations.length / this.getRegistrationSearchParams.searchLimit) +
          1 || "Number is greater than max page",
      ],
      limitItems: [10, 20, 30],
      limitModel: 10,
      testForm: false,
      show: false,
      textCopiedContainer: false,
      devices: [],
      headers: REGISTRATION_HEADERS.filter((header) => header.defaultVisible),
      options: {},
      hits: 0,
      currentItem: null,
      viewItemDialog: false,
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 0,
      },
      fullView: false,
      selectedRegs: [],
      showSuccess: false,
      showError: false,
      errorMsg: "",
      dialog: false,
      dialogPass: false,
      successType: "",
      change_status: {
        status_object: {
          changeStatusLoader: false,
          changeStatus: false,
        },
        validityType: "",
        validity_duration: "",
        radio_status: [
          { label: "Limited", value: "1", color: "indigo" },
          { label: "Always", value: "2", color: "indigo" },
        ],
      },
      change_pass: {
        changePass: false,
        changePassword: false,
        changePasswordLoader: false,
        valid: false,
        new_pass: {
          newPass: null,
          newPassRules: [(v) => !!v || "New password is required"],
          showNewPass: false,
        },
        confirm_pass: {
          confirmPass: null,
          confirmPassRules: [
            (v) => !!v || "Confirm new password is required",
            (v) =>
              this.change_pass.new_pass.newPass === v || "New passwords do not match",
          ],
          showConfirmPass: false,
        },
      },
      dontSort: true,
      rightClickObject: {
        showContext: false,
        posY: 0,
        posX: 0,
      },
      selectedItems: [],
    };
  },
  computed: {
    ...mapGetters(["getRegistrations", "getRegistrationSearchParams"]),
    page: {
      get: function () {
        return this.getRegistrationSearchParams.searchOffset;
      },
      set: async function (page) {
        try {
          if (page !== this.getRegistrationSearchParams.searchOffset) {
            await this.updateRegistrationSearchParams({
              ...this.getRegistrationSearchParams,
              searchOffset: page
            });
          }
        } catch (err) {
          this.actionResponse({message: err.response?.data?.msg || "Could not read registrations"})
        }
      },
    },
  },
  methods: {
    ...mapActions(["updateRegistrationSearchParams", "updateRegistrations"]),
    customSort(items, index, isDesc) {
      if (this.dontSort) {
        return items;
      }
      items.sort((a, b) => {
        if (isDesc !== "false") {
          return a[index] < b[index] ? -1 : 1;
        } else {
          return b[index] < a[index] ? -1 : 1;
        }
      });
      return items;
    },
    onResize() {
      this.isMobileView = window.innerWidth < 600;
    },
    async goToPageClicked() {
      try {
        this.goToPageFormValid = this.$refs.form.validate();
        if (this.goToPageFormValid) {
          await this.updateRegistrationSearchParams({
            ...this.getRegistrationSearchParams,
            searchOffset: parseInt(this.goToPageModel)
          });
        }
      } catch (err) {
        this.actionResponse({message: err.response?.data?.msg || "Could not read registrations"})
      }
    },
    async limitItemsChanges(searchLimit) {
      try {
        await this.updateRegistrationSearchParams({
          ...this.getRegistrationSearchParams,
          searchLimit
        });
      } catch (err) {
        this.actionResponse({message: err.response?.data?.msg || "Could not read registrations"})
      }
    },
    clearPassVals() {
      this.change_pass.changePassword = false;
      this.change_pass.new_pass.newPass = null;
      this.change_pass.confirm_pass.confirmPass = null;
    },
    changePasswordFunction({ password, device }) {
      if (this.change_pass.new_pass.newPass !== this.change_pass.confirm_pass.confirmPass) {
        this.actionResponse({ message: "Passwords must match" });
        return;
      }
      this.change_pass.changePasswordLoader = true;
      const procid = this.getRegistrationSearchParams.procid;
      const protocol = device.regtype;
      let params = {
        regid: device.regid,
        password: password,
      };

      pgwyClient.updateRegistration(procid, protocol, params)
        .then(async (res) => {
          this.change_pass.changePasswordLoader = false;
          this.change_pass.changePassword = false;
          this.change_pass.new_pass.newPass = null;
          this.change_pass.confirm_pass.confirmPass = null;
          this.dialogPass = false;
          this.successType = "password";
          await this.updateRegistrations();
          this.actionResponse({ success: true });
        })
        .catch((err) => {
          this.change_pass.changePasswordLoader = false;
          this.successType = "password";
          this.actionResponse({ message: err.response?.data?.msg || "Could not update registration(s)" });
        });
    },
    openActionStatus(item) {
      this.rightClickObject.showContext = false;
      this.currentItem = item;
      this.dialogPass = false;
      this.change_status.status_object.changeStatus = true;
      this.change_status.status_object.changeStatusLoader = false;
      this.change_status.validity_duration = "";
      this.change_status.validityType = "";
      this.validityType = "";
      this.dialog = true;
    },
    openActionPassword(item) {
      this.currentItem = item;
      this.dialog = false;
      this.change_pass.changePassword = true;
      this.change_pass.changePasswordLoader = false;
      this.change_pass.new_pass.newPass = null;
      this.change_pass.confirm_pass.confirmPass = null;
      this.dialogPass = true;
    },

    clearStatusVals() {
      this.change_status.status_object.changeStatus = false;
      this.change_status.validityType = "";
      this.change_status.validity_duration = "";

      return this.currentItem.status === "open";
    },
    toolbarUpdate(val) {
      this.successType = val;
    },
    changeStatusFunction({ status, validity, device }) {
      this.change_status.status_object.changeStatusLoader = true;

      let params = {
        regid: device.regid,
        status,
        validity,
      };
      const procid = this.getRegistrationSearchParams.procid;
      const protocol = device.regtype;

      if (this.change_status.validityType === "2") {
        params.validity = "always";
      }

      pgwyClient.updateRegistration(procid, protocol, params)
        .then(async (res) => {
          this.sortByColumn = "creationdate";
          this.sortDescending = true;
          this.change_status.validity_duration = "";
          this.change_status.status_object.changeStatusLoader = false;
          this.dialog = false;
          this.change_status.validityType = "";
          this.validityType = "";
          this.successType = "status";
          await this.updateRegistrations();
          this.actionResponse({ success: true });
        })
        .catch((err) => {
          this.change_status.status_object.changeStatusLoader = false;
          this.successType = "status";
          this.actionResponse({ message: err.response?.data?.msg || "Operation failed" });
        });
    },
    updateCurrentDevice() {
      this.currentItem = this.getDevices.registrations.find(
        (device) => device.regid === this.currentItem.regid
      );
    },
    columnsChanged() {
      this.headers =
        REGISTRATION_HEADERS.filter((header) => {
          return header.required || this.registrationsToolBar.columnsModel.includes(header.text);
        });
      // localStorage.setItem("localHeaders", JSON.stringify(this.headers));
    },
  },
  updated() {
    this.makeHeadersDraggable(false);
  },
};